module.exports = __webpack_public_path__ + "static/media/discover.84b1bcd3.png";